/*
*
* Don't put trailing / on api url
*
* */
export const environment = {
  // api: 'http://localhost:8000/api',
  api: 'https://vex-api.e-hytec.dev/api',
  videos: 'https://vex.e-hytec.dev/videos',
  production: false

};

